module.exports = __webpack_public_path__ + "static/media/Yellowstone.c9db0623.jpg";